import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';

const reviews = [
  {
    get role() {
      return t('common.coo');
    },
    get company() {
      return t('extra.cryptoExchangeBerlin');
    },
    get quote() {
      return t('extra.weDonTWorryAboutKycAnymoreRavenDoesIt');
    },
  },
  {
    get role() {
      return t('extra.headOfCompliance');
    },
    get company() {
      return t('extra.neobankAmsterdam');
    },
    get quote() {
      return t('extra.weDonTWorryAboutKycAnymoreRavenDoesIt');
    },
  },
  {
    get role() {
      return t('common.coo');
    },
    get company() {
      return t('extra.fintechDubai');
    },
    get quote() {
      return t('extra.weDonTWorryAboutKycAnymoreRavenDoesIt');
    },
  },
  {
    get role() {
      return t('extra.riskManager');
    },
    get company() {
      return t('extra.governmentInstitutionParis');
    },
    get quote() {
      return t('extra.weDonTWorryAboutKycAnymoreRavenDoesIt');
    },
  },
  {
    get role() {
      return t('common.coo');
    },
    get company() {
      return t('extra.cryptoExchangeLondon');
    },
    get quote() {
      return t('extra.weDonTWorryAboutKycAnymoreRavenDoesIt');
    },
  },
];

const ReviewCard = ({ role, company, quote }: { role: string; company: string; quote: string }) => {
  useLocale();

  return (
    <div className="min-w-72 max-w-xs shrink-0 rounded-xl border border-landing-card-border bg-landing-card-bg p-5">
      <p className="font-libre-baskerville font-semibold text-landing-heading-sm text-xs">{role}</p>
      <p className="mb-3 text-landing-muted text-xs">{company}</p>
      <p className="text-landing-body text-xs leading-relaxed">
        {t('landing.')}
        {quote}
        {t('landing.2')}
      </p>
    </div>
  );
};

export const CustomerReviewsSection = ({ className }: { className?: string }) => {
  useLocale();

  const doubled = [...reviews, ...reviews];

  return (
    <section className={className}>
      <div className="mx-auto mb-10 max-w-6xl px-6 lg:px-8">
        {/* Badge */}
        <span className="mb-4 inline-block rounded-full bg-landing-pill-bg px-3 py-1 font-medium text-landing-pill-text text-xs">
          {t('landing.customerReviews')}{' '}
        </span>
        <h2 className="mb-3 font-bold font-libre-baskerville text-4xl text-landing-heading">
          {t('landing.whatOurCustomersSay')}{' '}
        </h2>
        <p className="text-landing-body text-sm">
          {t('landing.realFeedbackFromPeopleWhoHaveExperiencedTheRaven')}{' '}
        </p>
      </div>

      {/* Row 1 — scroll start */}
      <div className="relative mb-4 w-full overflow-hidden">
        <div className="flex animate-marquee gap-4" style={{ width: 'max-content' }}>
          {doubled.map((r, i) => (
            <ReviewCard key={i} {...r} />
          ))}
        </div>
      </div>

      {/* Row 2 — scroll end */}
      <div className="relative w-full overflow-hidden">
        <div className="flex animate-marquee-reverse gap-4" style={{ width: 'max-content' }}>
          {doubled.map((r, i) => (
            <ReviewCard key={i} {...r} />
          ))}
        </div>
      </div>
    </section>
  );
};
